import HomeListings from 'constants/hashUrl';

export default class UrlSubdirectoryTypes {
  /**
   * The function return the Url Subdirectory name for Communities.
   * @returns The method `Communities` is returning an instance of the class
   * `communities`.
   */
  static get Communities() {
    const configuration = {
      name: 'communities',
      pageType: 'Community_Results',
      luxLabel: 'Community Results',
    };
    return this.getInstance('communities', configuration);
  }

  /**
   * The function return the Url Subdirectory name for Homes.
   * @returns The method `Homes` is returning an instance of the class
   * `homes`.
   */
  static get Homes() {
    const configuration = {
      name: 'homes',
      pageType: 'Home_Results',
      luxLabel: 'Home Results',
      urlFunction: 'communities',
      urlHash: HomeListings,
    };
    return this.getInstance('homes', configuration);
  }

  /**
   * The function return the Url Subdirectory name for Builder Directory.
   * @returns The method `Builders` is returning an instance of the class
   * `builders`.
   */
  static get Builders() {
    const configuration = {
      name: 'builders',
      pageType: 'Builders',
      luxLabel: 'Builder Directory',
    };
    return this.getInstance('builders', configuration);
  }

  /**
   * The function return the Url Subdirectory name for Condo Developments.
   * @returns The method `CondoDevelopment` is returning an instance of the class
   * `condo-developments`.
   */
  static get CondoDevelopment() {
    const configuration = {
      name: 'condo-developments',
      pageType: 'Condo_Developments',
      luxLabel: 'Community Results',
      urlFunction: 'condos-townhomes',
    };
    return this.getInstance('condo-developments', configuration);
  }

  /**
   * The function return the Url Subdirectory name for Condo Townhomes.
   * @returns The method `CondosAndTownHomes` is returning an instance of the class
   * `condo-townhomes`.
   */
  static get CondosAndTownHomes() {
    const configuration = {
      name: 'condo-townhomes',
      pageType: 'Condo_Townhomes',
      luxLabel: 'Home Results',
      urlFunction: 'condos-townhomes',
      urlHash: HomeListings,
    };
    return this.getInstance('condo-townhomes', configuration);
  }

  /**
   * The function return the Url Subdirectory name for Single Family Homes.
   * @returns The method `SingleFamilyHomes` is returning an instance of the class
   * `single-family-homes`.
   */
  static get SingleFamilyHomes() {
    const configuration = {
      name: 'single-family-homes',
      pageType: 'Single_Family_Homes',
      luxLabel: 'Home Results',
      urlFunction: 'single-family',
      urlHash: HomeListings,
    };
    return this.getInstance('single-family-homes', configuration);
  }

  /**
   * The function return the Url Subdirectory name for Single Family Communities.
   * @returns The method `SingleFamilyCommunties` is returning an instance of the class
   * `single-family-communities`.
   */
  static get SingleFamilyCommunities() {
    const configuration = {
      name: 'single-family-communities',
      pageType: 'Single_Family_Communities',
      luxLabel: 'Community Results',
      urlFunction: 'single-family',
    };
    return this.getInstance('single-family-communities', configuration);
  }

  /**
   * The function return the Url Subdirectory name for Custom Homes.
   * @returns The method `CustomHomes` is returning an instance of the class
   * `custom-homes`.
   */
  static get CustomHomes() {
    const configuration = {
      name: 'custom-homes',
      pageType: 'Custom_Homes',
      luxLabel: 'Custom Home Results',
    };
    return this.getInstance('custom-homes', configuration);
  }

  /**
   * The function return the Url Subdirectory name for Build On Your Lot.
   * @returns The method `OnYourLot` is returning an instance of the class
   * `on-your-lot`.
   */
  static get OnYourLot() {
    const configuration = {
      name: 'on-your-lot',
      pageType: 'BoylResults',
      luxLabel: 'Build On Your Lot Results',
    };
    return this.getInstance('on-your-lot', configuration);
  }

  /**
   * The function return the Url Subdirectory name for Custom Builders.
   * @returns The method `CustomBuilders` is returning an instance of the class
   * `builders`.
   */
  static get CustomBuilders() {
    const configuration = {
      name: 'custom-builders',
      pageType: 'CustomBuilders',
      luxLabel: 'Custom Builder Results',
    };
    return this.getInstance('custom-builders', configuration);
  }

  /**
   * The function return the Url Subdirectory name for Floor Plans.
   * @returns The method `FloorPlans` is returning an instance of the class
   * `floor-plans`.
   */
  static get FloorPlans() {
    const configuration = {
      name: 'floor-plans',
      pageType: 'FloorPlans',
      luxLabel: 'Home Results',
    };
    return this.getInstance('floor-plans', configuration);
  }

  /**
   * The function return the Url Subdirectory name for Model Homes.
   * @returns The method `ModelHomes` is returning an instance of the class
   * `model-homes`.
   */
  static get ModelHomes() {
    const configuration = {
      name: 'model-homes',
      pageType: 'ModelHomes',
      luxLabel: 'Home Results',
    };
    return this.getInstance('model-homes', configuration);
  }

  /**
   * The function return the Url Subdirectory name for Learning Center.
   * @returns The method `LearningCenter` is returning an instance of the class
   * `learn`.
   */
  static get LearningCenter() {
    const configuration = {
      pageType: 'Learning Center',
      luxLabel: 'Blog',
    };
    return this.getInstance('learn', configuration);
  }

/**
  * The NewsAndTrends function returns an instance with configuration settings for a NewsAndTrends
  * page.
  * @returns An instance of the 'news' with the configuration for the page type as 'NewsAndTrends' and
  * the luxLabel as 'News' is being returned.
  */
  static get SpecDetail() {
    const configuration = {
      name: 'specdetail',
      pageType: 'SpecDetail',     
    };
    return this.getInstance('specdetail', configuration);
  }

  /**
  * The Plan function returns an instance with configuration settings for a Plan
  * page.
  * @returns An instance of the 'plan' with the configuration for the page type as 'Plan'.
  */
  static get Plan() {
    const configuration = {
      name: 'plan',
      pageType: 'PlanDetail',     
    };
    return this.getInstance('plan', configuration);
  }

  /**
  * The Community function returns an instance with configuration settings for a Community
  * page.
  * @returns An instance of the 'community' with the configuration for the page type as 'Community'.
  */
  static get Community() {
    const configuration = {
      name: 'community',
      pageType: 'CommunityDetail',     
    };
    return this.getInstance('community', configuration);
  }

/**
  * The NewsAndTrends function returns an instance with configuration settings for a NewsAndTrends
  * page.
  * @returns An instance of the 'news' with the configuration for the page type as 'NewsAndTrends' and
  * the luxLabel as 'News' is being returned.
  */
  static get NewsAndTrends() {
    const configuration = {
      pageType: 'NewsAndTrends',
      luxLabel: 'News',
    };
    return this.getInstance('news', configuration);
  }

  static get State() {
    const configuration = {
      name: 'state',
      pageType: 'State',
      luxLabel: 'State',
      urlFunction: 'communities',
    };
    return this.getInstance('state', configuration);
  }

  static fromKey(key) {
    const subDirectoryTypeMap = {
      communities: UrlSubdirectoryTypes.Communities,
      homes: UrlSubdirectoryTypes.Homes,
      builders: UrlSubdirectoryTypes.Builders,
      'condo-developments': UrlSubdirectoryTypes.CondoDevelopment,
      'condo-townhomes': UrlSubdirectoryTypes.CondosAndTownHomes,
      'single-family-homes': UrlSubdirectoryTypes.SingleFamilyHomes,
      'single-family-communities': UrlSubdirectoryTypes.SingleFamilyCommunities,
      'custom-homes': UrlSubdirectoryTypes.CustomHomes,
      'on-your-lot': UrlSubdirectoryTypes.OnYourLot,
      'custom-builders': UrlSubdirectoryTypes.CustomBuilders,
      'floor-plans': UrlSubdirectoryTypes.FloorPlans,
      'model-homes': UrlSubdirectoryTypes.ModelHomes,
      [UrlSubdirectoryTypes.LearningCenter.toString()]: UrlSubdirectoryTypes.LearningCenter,
      [UrlSubdirectoryTypes.NewsAndTrends.toString()]: UrlSubdirectoryTypes.NewsAndTrends,
      specdetail: UrlSubdirectoryTypes.SpecDetail,
      state: UrlSubdirectoryTypes.State,
      'plan': UrlSubdirectoryTypes.Plan,
      'community': UrlSubdirectoryTypes.Community,
    };

    return subDirectoryTypeMap[key];
  }

  /**
   * The getInstance function returns an instance of the SubDirectoryTypes class based on the
   * provided key, creating a new instance if one does not already exist.
   * @param key - The "name" parameter is a unique identifier used to determine which instance of the
   * "SubDirectoryTypes" class to create or retrieve.
   * @param configuration an object that contains various properties and values that are used to configure
   * the instance of the UrlSubdirectoryTypes class that is being created.
   * @returns The instance of the SubDirectoryTypes class with the specified key.
   */
  static getInstance(key, configuration) {
    configuration.name = key;

    if (!this.instances[key]) {
      this.instances[key] = new UrlSubdirectoryTypes(configuration);
    }
    return this.instances[key];
  }

  /**
   * The constructor function initializes an object with a given name property.
   * @param configuration - The `configuration` parameter is an object that contains the configuration
   * settings for the constructor. It may contain properties such as `name` and
   * `pageType`. The `name` property is a string that represents the name of the
   * configuration.
   */
  constructor(configuration) {
    this.name = configuration.name;
    this.pageType = configuration.pageType;
    this.luxLabel = configuration.luxLabel;
    this.urlFunction = configuration.urlFunction;
    this.urlHash = configuration.urlHash;
  }

  /**
   * The toString() function returns the name property of an object as a string.
   * @returns The name property of the object.
   */
  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(UrlSubdirectoryTypes, 'instances', { value: {} });
